import fingerprintService from '../../services/fingerprintService';

const state = {
  botResult: null,
  visitorID: fingerprintService.getVisitorID()
}

const mutations = {
  setBotResult(state, botResult) {
    state.botResult = botResult;
  },
  setVisitorID(state, visitorID) {
    state.visitorID = visitorID;
    fingerprintService.setVisitorID(visitorID);
  },
}

const getters = {
  botResult: state => state.botResult,
  isBot: state => state.botResult ? state.botResult.bot : false,
  visitorID: state => state.visitorID,
}

const actions = {
  detect({commit}) {
    return fingerprintService.detectBot()
      .then(result => {
        commit('setBotResult', result);
        return result;
      })
  },
  getVisitor({commit}) {
    return fingerprintService.getVisitor()
      .then(visitorID => {
        if (visitorID) {
          commit('setVisitorID', visitorID);
        }
        return visitorID;
      })
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
}

